import { HeaderVariantType } from './variants';
export const getHeaderStyles = (FOUNDATIONS, FONT) => {
    return {
        [HeaderVariantType.REGULAR]: {
            container: {
                gap: FOUNDATIONS.spacing_250,
            },
        },
    };
};
//# sourceMappingURL=styles.js.map